import React, { useEffect } from 'react'

import CreateMachineForm from '@/components/pages/Machines/Create/Form'
import CreateMachinePageHeader from '@/components/pages/Machines/Create/PageHeader'
import { useTanks } from '@/pages/Tank/Tank.hooks'

import { useCreateMachine } from './Create.hooks'

const CreateMachine = () => {
  const { createMachine, loading } = useCreateMachine()
  const { getAllTanks, tanks } = useTanks()

  useEffect(() => {
    getAllTanks()
  }, [getAllTanks])

  return (
    <>
      <CreateMachinePageHeader />
      <CreateMachineForm {...{ loading, tanks }} onSubmit={createMachine} />
    </>
  )
}

CreateMachine.displayName = 'CreateMachine'
export default CreateMachine
